module.exports = __webpack_public_path__ + "static/product_placeholder-f9162597559bf8df07c79be494e37b1d.png";